/* eslint-disable indent */
import React, { useContext, useRef } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { useSelector, useDispatch } from 'store';
import { ThemeContext } from 'styled-components';

import Icon from 'components/Icon';

import Input from './Input';
import { selectBrowser } from 'store/slices/browser';
import {
    closeOccupancyPopup,
    isOccupancyPopupOpen,
    openOccupancyPopup,
    selectOccupancyString,
    changeRoomCount,
    changeAdultsCount,
    changeChildrenCount,
    changeChildAge,
} from 'store/slices/searchBox';

const OccupancyInputContainer = ({ className, fullWidth }) => {
    const themeContext = useContext(ThemeContext);
    const dispatch = useDispatch();
    const containerRef = useRef();
    const browser = useSelector(selectBrowser);
    const isPopupOpen = useSelector(isOccupancyPopupOpen);
    const occupancyString = useSelector(selectOccupancyString);

    const onClick = () => {
        if (browser.size !== 'lg') {
            containerRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <OutsideClickHandler
            onOutsideClick={() => dispatch(closeOccupancyPopup())}
            disabled={!isPopupOpen}
        >
            <div className={className} onClick={onClick} ref={containerRef}>
                <div className="icon-container">
                    <Icon
                        type="room-toggle"
                        width="21px"
                        height="23px"
                        colour={themeContext.colours.primary}
                    />
                </div>
                <div className="input-container">
                    <Input
                        value={occupancyString}
                        openPopup={() => dispatch(openOccupancyPopup())}
                        closePopup={() => dispatch(closeOccupancyPopup())}
                        popup={isPopupOpen}
                        readOnly
                        className={className}
                        changeRoomCount={changeRoomCount}
                        changeAdultsCount={changeAdultsCount}
                        changeChildrenCount={changeChildrenCount}
                        changeChildAge={changeChildAge}
                        fullWidth={fullWidth}
                    />
                </div>
            </div>
        </OutsideClickHandler>
    );
};

export default OccupancyInputContainer;
